<main class="form-overview">
  <section class="form-overview__content">
    <header class="form-overview__header">
      <p class="form-overview__eyebrow">FormsHub Banking Demo</p>
      <h1>Demo forms</h1>
      <p>Choose a form to open it locally.</p>
    </header>

    <div class="form-overview__grid" aria-label="Available demo forms">
      @for (form of forms; track form.identifier) {
        <article class="form-overview__item">
          <div>
            <h2>{{ form.title }}</h2>
            <p>{{ form.identifier }}</p>
          </div>
          <a mat-flat-button [routerLink]="form.route">Open form</a>
        </article>
      }
    </div>
  </section>
</main>
